import React, { Component, Fragment } from 'react'
export default class TreeSelect extends Component {
  constructor(props) {
    super(props)    
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        onChangeTree: (filters) =>  this.props.onChange(filters)
      })
    })
    return <Fragment>{children}</Fragment>
  }
}
